import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function Toggle({onClick,data}) {
  return (
    <label class="switch">
    <input type="checkbox" checked={data} onChange={onClick}/>
    <span class="slider round"></span>
    </label>
  );
}

Toggle.propTypes = {
  style: PropTypes.shape(),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['', 'primary', 'simple']),
  disabled: PropTypes.bool,
};

Toggle.defaultProps = {
  type: '',
  className: '',
  style: {},
  disabled: false,
};

